import client from "shared/setupClient";
import { loader } from "graphql.macro";

const editChecklistMutation = loader("graphql/mutations/checklist/editChecklist.graphql");

export default function editChecklistAction() {
    return (dispatch, getState) => {
        const { manageChecklists } = getState();
        const { checklist } = manageChecklists;
        const {id, label, description, items} = checklist;
        const mappedItems = items.map(({label, type, position}, index) => {
            const nextPosition = typeof position === "number" ? position : index + 1;
            return {label, type, position: nextPosition};
        });
        const variables = {label, description, id, items: mappedItems};
        return client.mutate({ mutation: editChecklistMutation, variables });
    };
}
